import { Link } from 'react-router-dom';
import { useI18n } from '@/store/preferences';

export function NotFoundPage() {
  const { t } = useI18n();

  return (
    <div className="grid min-h-[70vh] place-items-center px-5 pt-20">
      <div className="text-center">
        <p className="text-xs font-medium text-faint">404</p>
        <h1 className="h2 mt-5">{t.common.notFound}</h1>
        <p className="mx-auto mt-4 max-w-sm text-pretty text-muted">{t.common.notFoundText}</p>
        <Link to="/" className="btn-outline mt-9">
          {t.common.goHome}
        </Link>
      </div>
    </div>
  );
}
